import { useContext, useMemo } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { AppContext } from "../contextProviders/AppContext";
import { translation } from "./Dictionary";

export default function AlreadyReservedDialog({ error }) {
  const navigate = useNavigate();
  const {
    handleActiveStep,
    handleClearCart,
    companies,
    showBackToStartBtn,
    language,
  } = useContext(AppContext);

  console.log(`Show back to start: ${showBackToStartBtn}`);
  console.log(
    "🚀 ~ file: AlreadyReservedDialog.jsx:37 ~ AlreadyReservedDialog ~ error:",
    error
  );
  let errorTitle = translation.get(language, "Something went wrong");
  let errorMsg = translation.get(language, "Something went wrong 2");
  if (error === "NOT_FOUND") {
    errorMsg = translation.get(language, "Something went wrong 4");
  }
  if (error === "EXPIRED") {
    errorMsg = translation.get(language, "Something went wrong 3");
  }

  if (error === "unknown") {
    errorMsg =
      translation.get(language, "Contact the dealer") +
      translation.get(language, "Reservation failed text");
  }

  const showReturnBtn = useMemo(() => {
    const hiddenOrigin = process.env.REACT_APP_HOSTING_URL_CUSTOMER;
    if (hiddenOrigin === window.location.origin) return false;
    return true;
  }, []);

  function P({ children }) {
    return (
      <Typography sx={{ margin: "1em 0px" }} variant="body1" component="p">
        {children}
      </Typography>
    );
  }
  const handleReturn = () => {
    handleActiveStep(0);
    handleClearCart();
    navigate("/");
  };

  return (
    <Dialog open={true}>
      <DialogTitle>
        <ErrorOutlineIcon
          fontSize="large"
          style={{ verticalAlign: "middle" }}
        />
        {errorTitle}
      </DialogTitle>
      <DialogContent>
        <P>{errorMsg}</P>
      </DialogContent>
      {showBackToStartBtn && (
        <DialogActions>
          <Button
            onClick={() => handleReturn()}
            color="primary"
            size="large"
            variant="contained"
            fullWidth
          >
            Palaa takaisin
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
